import React from "react";
import "./Separator.css";

export type SeparatorProps = {
  orientation?: "horizontal" | "vertical";
  className?: string;
};

export const Separator = ({
  orientation = "horizontal",
  className = "",
  ...props
}: SeparatorProps & React.ComponentPropsWithoutRef<"div">) => {
  
  const orientationClass = orientation === "vertical" ? "ds2-separator-vertical" : "ds2-separator-horizontal";

  return (
    <div 
      className={`ds2-separator ${orientationClass} ${className}`}
      role="separator"
      aria-orientation={orientation}
      {...props}
    />
  );
};